import { render } from "./brandManager.vue?vue&type=template&id=ab37823c&scoped=true&ts=true"
import script from "./brandManager.vue?vue&type=script&lang=ts"
export * from "./brandManager.vue?vue&type=script&lang=ts"

import "./brandManager.vue?vue&type=style&index=0&id=ab37823c&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab37823c"]])

export default __exports__